import { BehaviorSubject, combineLatest, map, Observable } from 'rxjs';

import { BaseChatManager } from './managers/base-chat.manager';

/** Реестр режимов чата и указатель на активный менеджер. */
export class ChatController {
    /** Фиксированный список менеджеров, задаётся при создании. */
    public readonly managers: BaseChatManager[];

    /** Активный режим чата. */
    public readonly activeManager$: Observable<BaseChatManager>;

    /** Сумма totalUnreadCount$ всех менеджеров. */
    public readonly totalUnreadCount$: Observable<number>;

    private readonly activeManagerSubject: BehaviorSubject<BaseChatManager>;

    public constructor(managers: BaseChatManager[], defaultManager: BaseChatManager) {
        this.managers = managers;
        this.activeManagerSubject = new BehaviorSubject<BaseChatManager>(defaultManager);
        this.activeManager$ = this.activeManagerSubject.asObservable();
        this.totalUnreadCount$ = combineLatest(managers.map(m => m.totalUnreadCount$)).pipe(
            map(counts => counts.reduce((acc, n) => acc + n, 0)),
        );

        defaultManager.init();
    }

    /**
     * Переключить активный режим.
     * Предыдущий менеджер получает destroy(), новый — init().
     */
    public selectManager(manager: BaseChatManager): void {
        const current = this.activeManagerSubject.getValue();

        if (current !== manager) {
            current.destroy();
            manager.init();
            this.activeManagerSubject.next(manager);
        }
    }

    /** Уничтожить активный менеджер и освободить ресурсы контроллера. */
    public destroy(): void {
        this.activeManagerSubject.getValue().destroy();
        this.activeManagerSubject.complete();
    }
}
